@if (ready()) {
  @let autoQuote = autoQuote$ | async;

  @if (autoQuote) {
    <div class="p-4">
      @let type = autoQuote.isRoundTrip ? PortalTripType.Round : PortalTripType.Oneway;

      <lead-details-title
        [from]="autoQuote.departureCityName"
        [to]="autoQuote.arrivalCityName"
        [type]="type"
      />

      @if (autoQuote.salesAgent; as agent) {
        <div class="d-flex flex-column mt-6 p-4 p-md-6 agent-card" data-id="agent-card">
          <div class="d-flex align-items-center">
            <img
              [src]="agent.picture || 'assets/icons/avatar.svg'"
              alt="agent"
              width="64"
              height="64"
              class="picture"
              data-id="agent-photo"
            />

            <div class="d-flex flex-column ml-4">
              <h3 class="semi-bold" data-id="agent-name">{{ agent.fullName }}</h3>
              <p class="mt-1">Senior Travel Expert</p>
              <a [href]="'tel:' + agent.phone" class="link" data-id="agent-phone">
                <p>{{ agent.phone | phone }}</p>
              </a>
            </div>
          </div>

          <p class="mt-4">
            I've added premium options on or around your dates. If your plans are flexible, I can
            look for more combinations that might reduce your prices or improve comfort. You can
            give a quick thumbs up/down on each option and also leave additional comments at the
            bottom of this page. I look forward to your feedback!
          </p>
        </div>
      }

      <div class="d-flex flex-column g-6 g-md-10 mt-6 mt-md-10">
        @for (portalOption of autoQuote.options; track portalOption) {
          <quick-option-itinerary
            [flightOption]="flightDisplayOption(autoQuote, portalOption)"
            [passengerCountOverride]="autoQuote.passengerCount ?? undefined"
            [quoteToken]="autoQuote.token"
            [autoQuoteOption]="portalOption"
            [isFirstQuoteFeedbackRow]="$first"
          />
        }
      </div>

      <form class="flex-1 mt-6 mt-md-10 d-md-flex" [formGroup]="noteForm" (ngSubmit)="noteSubmit()">
        <ds-input
          class="flex-1"
          formControlName="noteControl"
          label="Add a note (optional)"
          placeholder="What would you like us to adjust?"
          data-id="note"
        />

        <ds-button
          (click)="noteSubmit()"
          class="mt-3 mt-md-auto ml-md-3"
          [fullWidth]="true"
          data-id="submit"
          [disabled]="submitting()"
          label="Share with your travel expert"
        />
      </form>
    </div>
  }
} @else {
  <quote-loading-page />
}
